const trimWhiteSpace = (str) => str.replace(/\s+/g, " ");
function cssThemedValue(value) {
  return (context) => {
    if (!context) {
      throw new Error(
        trimWhiteSpace(
          `Missing styled-components context. The cssThemedValue function must be used
           inside a styled-components component and ThemeProvider must be set up.`
        )
      );
    }
    if (!context.theme.cbThemeMode) {
      throw new Error("Missing `cbThemeMode` definition in styled-components theme.");
    }
    const cbThemeMode = context.theme.cbThemeMode;
    return cbThemeMode === "lightHighContrast" && !value[cbThemeMode] ? value.light : value[cbThemeMode];
  };
}
export {
  cssThemedValue
};
//# sourceMappingURL=index.js.map
